<template>
  <div class="ui two column grid" style="margin-left: 20px; margin-right: 20px;">
    <div class="row">
      <div class="column">
        <div class="ui two column grid">
          <div class="row">
            <div class="column"><h3 style="font-weight: normal;">Von</h3></div>
            <div class="column"><h3 style="font-weight: normal;">Bis</h3></div>
          </div>
          <div class="row">
            <div class="column">
              <div class="item">
                <date-picker v-model="startDate" lang="de" :not-after="new Date()" format="DD.MM.YYYY" :first-day-of-week="1"></date-picker>
              </div>
            </div>
            <div class="column">
              <div class="item">
                <date-picker v-model="endDate" lang="de" :not-after="new Date()" format="DD.MM.YYYY" :first-day-of-week="1"></date-picker>
              </div>
            </div>
          </div>
          <div class="row row-column">
            <button class="ui primary button" @click="setCurrentWeek">
              laufende Woche
            </button>
            <button class="ui primary button" @click="setCurrentMonth">
              laufender Monat
            </button>
            <button class="ui primary button" @click="setLastWeek">
              letzte Woche
            </button>
            <button class="ui primary button" @click="setLastMonth">
              letzter Monat
            </button>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="ui two column grid">
          <div class="row"></div>
          <div class="row row-column">
            <div class="">
              <p style="margin-bottom: 0;"><small>Gesamte Zeit:</small></p>
              <p>
                <b v-if="totalHours > 0" style="font-size: 150%;">{{totalHours}}</b>
                {{totalHours > 0 ? ' Stunden' : ''}}
                <small v-if="totalHours > 0 && totalMinutes > 0"> und </small>
                <b v-if="totalMinutes > 0" style="font-size: 150%;">{{totalMinutes}}</b>
                {{(totalMinutes > 0 ? ' Minuten' : '')}}
              </p>
              <hr v-if="totalHours === 0 && totalMinutes === 0" style="width: 1em; margin-left: 1em;">
            </div>
          </div>
          <div class="row row-column">
            <div class="">
              <p style="margin-bottom: 0;"><small>Pausen Zeit:</small></p>
              <p>
                <b v-if="pauseHours > 0" style="font-size: 150%;">{{pauseHours}}</b>
                {{pauseHours > 0 ? ' Stunden' : ''}}
                <small v-if="pauseHours > 0 && pauseMinutes > 0"> und </small>
                <b v-if="pauseMinutes > 0" style="font-size: 150%;">{{pauseMinutes}}</b>
                {{(pauseMinutes > 0 ? ' Minuten' : '')}}
              </p>
              <hr v-if="pauseHours === 0 && pauseMinutes === 0" style="width: 1em; margin-left: 1em;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="padding-bottom: 0;">
      <div class="column">
        <bar-chart v-if="chartsVisible" id="chart1" :chartdata="tagChartData" :options="tagChartOptions" :styles="tagChartStyle"/>
      </div>
      <div class="column">
        <bar-chart v-if="chartsVisible" id="chart2" :chartdata="topicChartData" :options="topicChartOptions" :styles="tagChartStyle"/>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import BarChart from '@/components/BarChart';
import moment from 'moment';

export default {
        name: 'Stats',
        components: {
          DatePicker,
          BarChart
        },
        props: ['date'],
        data: function () {
          return {
            data: {}, // {notes: "", date: [workLogs: {topic, from, to, isBreak}, startTime: timestamp], tags: []}
            startDate: new Date(),
            endDate: new Date(),
            chartsVisible: true,
            chartHeight: 400,
            tagChartData: {
              labels: [],
              datasets: [{
                label: '',
                backgroundColor: '#8fc2e7',
                borderColor: '#8fc2e7',
                borderWidth: 1,
                data: []
              }]
            },
            tagChartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Zeit (in Stunden)'
                  }
                }],
                xAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: 'Tag'
                  }
                }]
              },
              legend: {
                display: false
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem) {
                    let value = tooltipItem.yLabel;
                    const hours = parseInt(value);
                    value -= hours;
                    const minutes = Math.round(value * 60);
                    return (hours > 0 ? hours + 'h ' : '') + (minutes > 0 ? minutes + 'm' : '');
                  }
                }
              }
            },
            topicChartData: {
              labels: [],
              datasets: [{
                label: '',
                backgroundColor: '#8fc2e7',
                borderColor: '#8fc2e7',
                borderWidth: 1,
                data: []
              }]
            },
            topicChartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Zeit (in Stunden)'
                  }
                }],
                xAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: 'Thema'
                  }
                }]
              },
              legend: {
                display: false
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem) {
                    let value = tooltipItem.yLabel;
                    const hours = parseInt(value);
                    value -= hours;
                    const minutes = Math.round(value * 60);
                    return (hours > 0 ? hours + 'h ' : '') + (minutes > 0 ? minutes + 'm' : '');
                  }
                }
              }
            }
          }
        },
        watch: {
          data: {
            handler() {
              localStorage.setItem('data', JSON.stringify(this.data));
            },
            deep: true,
          },
          startDate: {
            handler() {
              this.updateChartData();
            }
          },
          endDate: {
            handler() {
              this.updateChartData();
            }
          }
        },
        computed: {
          tagChartStyle: function () {
            return {
              height: this.chartHeight + 'px',
              position: 'relative'
            }
          },
          totalTime: function () {
            const dates = this.getRelevantDateKeys();
            let totalTime = 0;
            for (const date of dates) {
              const workLogs = this.getWorkLogsWithoutBreaks(date);
              for (const log of workLogs) {
                totalTime += (log.to - log.from);
              }
            }
            return totalTime;
          },
          totalHours: function () {
            return Math.floor(this.totalTime / 3600000);
          },
          totalMinutes: function () {
            return Math.floor(this.totalTime / 60000 - Math.floor(this.totalTime / 3600000) * 60);
          },
          totalPause: function () {
            const dates = this.getRelevantDateKeys();
            let totalPause = 0;
            for (const date of dates) {
              const workLogs = this.data[date].workLogs;
              for (const log of workLogs) {
                if (log.isBreak) {
                  totalPause += (log.to - log.from);
                }
              }
            }
            return totalPause;
          },
          pauseHours: function () {
            return Math.floor(this.totalPause / 3600000);
          },
          pauseMinutes: function () {
            return Math.floor(this.totalPause / 60000 - Math.floor(this.totalPause / 3600000) * 60);
          }
        },
        created: function () {
          try {
            this.data = JSON.parse(localStorage.getItem('data'));
          } catch (e) {
            console.warn("Could not Parse LocalStorage", e);
          }

          if (this.data == null) {
            this.data = {
              tags: {},
              tagTitleToId: {}
            };
          }

          this.startDate = this.date;
          this.endDate = this.date;

          this.updateChartData();
        },
        mounted () {
          window.addEventListener("resize", this.resizeChart);
          setTimeout(() => {
            this.resizeChart();
          }, 1);
          this.setCurrentWeek();
        },
        beforeDestroy () {
          window.removeEventListener("resize", this.resizeChart);
        },
        methods: {
            getRelevantDateKeys: function () {
              let startDate = this.startDate;
              startDate.setHours(0);
              startDate.setMinutes(0);
              startDate.setSeconds(0);
              startDate.setMilliseconds(0);

              const dataKeys = Object.keys(this.data);
              const dateRegex = new RegExp("^[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]$");
              let dates = [];
              for (const dataKey of dataKeys) {
                if (dateRegex.test(dataKey)) {
                  const dateKeyDate = new Date(dataKey);
                  dateKeyDate.setHours(0);
                  dateKeyDate.setMinutes(0);
                  dateKeyDate.setSeconds(0);
                  dateKeyDate.setMilliseconds(0);

                  if (startDate <= dateKeyDate && dateKeyDate <= this.endDate) {
                    dates.push(dataKey);
                  }
                }
              }
              return dates;
            },
            updateChartData: function () {
              this.chartsVisible = false;
              const dates = this.getRelevantDateKeys();
              let tags = {};
              let topics = {};
              for (const date of dates) {
                const workLogs = this.getWorkLogsWithoutBreaks(date);
                for (let i = 0; i < workLogs.length; i++) {
                  const log = workLogs[i];
                  const topic = log.topic.length > 20 ? log.topic.substring(0, 20) + '...' : log.topic;
                  if (!topics.hasOwnProperty(topic)) {
                    topics[topic] = 0;
                  }
                  topics[topic] += (log.to - log.from) / 3600000;
                  if (log.hasOwnProperty('tags') && log.tags.length > 0) {
                    for (const tag of log.tags) {
                      if (!tags.hasOwnProperty(this.data.tags[tag].title)) {
                        tags[this.data.tags[tag].title] = 0;
                      }
                      tags[this.data.tags[tag].title] += (log.to - log.from) / 3600000;
                    }
                  } else {
                    if (!tags.hasOwnProperty('Sonstiges')) {
                      tags.Sonstiges = 0;
                    }
                    tags.Sonstiges += (log.to - log.from) / 3600000;
                  }
                }
              }

              this.tagChartData.labels = Object.keys(tags);
              let tagData = [];
              for (const label of this.tagChartData.labels) {
                tagData.push(tags[label]);
              }
              this.tagChartData.datasets[0].data = tagData;
              this.topicChartData.labels = Object.keys(topics);
              let topicData = [];
              for (const label of this.topicChartData.labels) {
                topicData.push(topics[label]);
              }
              this.topicChartData.datasets[0].data = topicData;

              setTimeout(() => {
                this.chartsVisible = true;
              }, 1);
            },
            resizeChart: function () {
              const offsetTop = document.getElementById('chart1').getBoundingClientRect().y;
              const innerHeight = window.innerHeight;
              const chartHeight = innerHeight - offsetTop;
              this.chartHeight = chartHeight > 150 ? (chartHeight < 600 ? chartHeight : 600) : 150;
            },
            getWorkLogsWithoutBreaks: function (date) {
              let workLogsWithoutBreaks = [];
              for (const workLog of this.data[date].workLogs) {
                if (!workLog.isBreak) {
                  workLogsWithoutBreaks.push(workLog);
                }
              }
              return workLogsWithoutBreaks;
            },
            setCurrentWeek: function () {
              this.startDate = moment().isoWeekday(1).toDate();
              this.endDate = new Date();
            },
            setCurrentMonth: function () {
              this.startDate = moment().startOf('month').toDate();
              this.endDate = new Date();
            },
            setLastWeek: function () {
              this.startDate = moment().isoWeekday(-6).toDate();
              this.endDate = moment().isoWeekday(0).toDate();
            },
            setLastMonth: function () {
              this.startDate = moment().subtract(1, 'month').startOf('month').toDate();
              this.endDate = moment().subtract(1, 'month').endOf('month').toDate();
            }
        }
    }
</script>

<style scoped>
div.row-column {
  padding-left: 1rem !important;
}
</style>
